<template>
  <ElCard
    class="completed-appointments-statistic-card"
    v-loading="loading"
    :header="$t('Statistic.CorrectlyCompletedAppointments')"
    :shadow="shadow">
    <div class="completed-appointments-statistic-card__content">
      <div
        class="completed-appointments-statistic-card__info completed-appointments-statistic-card-info">
        <div class="completed-appointments-statistic-card-info__value">{{ valueString }}</div>
        <div
          :class="[
            'completed-appointments-statistic-card-info__percentage',
            percentageDirectionClass,
          ]">
          <div class="completed-appointments-statistic-card-info__percentage-icon">
            <MiIcon :icon="isPercentageIncrease ? 'INCREASE_PERCENTAGE' : 'DECREASE_PERCENTAGE'" />
          </div>
          <div class="completed-appointments-statistic-card-info__percentage-value">
            {{ percentageString }}
          </div>
        </div>
      </div>

      <Vue3Apexcharts
        class="completed-appointments-statistic-card__chart"
        type="donut"
        width="190"
        :options="chartOptions"
        :series="series"
        ref="chart" />
    </div>

    <div class="completed-appointments-statistic-card__legend">
      <div class="completed-appointments-statistic-card__legend-item">
        <div class="completed-appointments-statistic-card__legend-icon"></div>
        <div class="completed-appointments-statistic-card__legend-text">
          {{ $t(`Statistic.Incomplete`) }}
        </div>
      </div>
      <div class="completed-appointments-statistic-card__legend-item">
        <div class="completed-appointments-statistic-card__legend-icon"></div>
        <div class="completed-appointments-statistic-card__legend-text">
          {{ $t(`Statistic.Completed`) }}
        </div>
      </div>
    </div>
  </ElCard>
</template>

<script>
import Vue3Apexcharts from 'vue3-apexcharts';

import { MiIcon } from '~shared/ui';

export default {
  name: 'CompletedAppointmentsStatisticCard',
  components: { Vue3Apexcharts, MiIcon },
  props: {
    /** @type {Array<string>} period - Array<DATE_FORMAT> */
    period: Array,
    shadow: {
      type: String,
      default: 'never',
    },
    value: Number,
    percentage: Number,
    loading: Boolean,
  },
  computed: {
    valueNum() {
      if (this.value === null || this.value === undefined) return 0;
      return Number.isInteger(this.value) ? this.value : Number(this.value.toFixed(2));
    },

    percentageNum() {
      if (this.percentage === null || this.percentage === undefined) return 0;
      return this.percentage === 0 ? this.percentage : Number(this.percentage.toFixed(2));
    },

    valueString() {
      return `${this.valueNum}%`;
    },

    percentageString() {
      return (this.percentageNum > 0 ? `+${this.percentageNum}` : this.percentageNum) + '%';
    },

    isPercentageIncrease() {
      return this.percentageNum >= 0;
    },

    percentageDirectionClass() {
      return `completed-appointments-statistic-card-info__percentage_${
        this.isPercentageIncrease ? 'success' : 'danger'
      }`;
    },

    series() {
      return [this.valueNum, 100 - this.valueNum];
    },

    chartOptions() {
      return {
        chart: {
          width: 190,
          type: 'donut',
        },
        plotOptions: {
          pie: {
            startAngle: 120,
            endAngle: -240,
          },
        },
        colors: ['#1780FB', '#811FFF'],
        labels: [this.$t(`Statistic.Completed`), this.$t(`Statistic.Incomplete`)],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        fill: {
          type: 'gradient',
        },
      };
    },
  },
  watch: {
    series: {
      handler(value) {
        this.$refs.chart.updateSeries(value);
      },
    },
    chartOptions: {
      handler(value) {
        this.$refs.chart.updateOptions(value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/statistic.locales.json" />
